import md5 from 'js-md5'
import Axios from "axios";
import UploadImage from "@kugou/upload-image"

//添加水印
function addWaterMarker(imgsrc, str, cb, failCb){
    //创建 canvas 元素
    var canvas = document.createElement('canvas');
    //document.body.appendChild(canvas);

    // 隐藏 canvas 元素
    canvas.style.display = 'none';
    canvas.style.zIndex = '-999'
    // 获取 canvas 元素工具箱
    var ctx = canvas.getContext('2d');
    const img = new Image()
    img.setAttribute( 'crossorigin', 'anonymous' )
    img.src = imgsrc
    img.onload = ()=>{
        let width = img.width;
        let height = img.height;
        let ra = 1;
        if (width >= 5000 || height >= 5000) {
          ra = ra < 1 / 2 ? ra : 1 / 2;
        }
        canvas.width = width * ra;
        canvas.height = height * ra;
        ctx.drawImage(img, 0, 0, width * ra, height * ra);
        // 设置文字倾斜角度为 -25 度以及样式
        ctx.rotate(-25 * Math.PI / 180);
        ctx.font = "800 30px Microsoft JhengHei";
        ctx.fillStyle = "rgba(255,255,255,.5)";
        ctx.textAlign = 'center';
        ctx.textBaseline = 'Middle';
        // 动态改变字体大小
        if(ctx.measureText(str).width > 180) {
            var size = 180 / str.length * (img.width/1000)
            ctx.font = '800 ' + size +'px '+ ' Microsoft JhengHei'
        }
        /* 
            双重遍历，
            当 宽度小于页面宽度时，
            当 高度小于页面高度时，
            这里的宽高可以适当写大，目的是为了让水印文字铺满
        */
        for(let i = (img.width*0.5)*-1; i<img.width; i+=img.width/4) {
            for(let j = 0; j<img.height*1.5; j+=img.height/5) {
            // 填充文字，x 间距, y 间距
            ctx.fillText(str, i, j)
            }
        }
        // 将 canvas 转化为图片并且设置为背景
        let resultImgSrc = canvas.toDataURL("image/png")
        /* let resultImg = new Image();
        resultImg.src = resultImgSrc
        resultImg.style.position = 'absolute'
        resultImg.style.top = '0px'
        resultImg.style.left = '0px'
        resultImg.style.width = '100%'
        document.body.appendChild(resultImg)
        resultImg.addEventListener("click",function(){
            document.body.removeChild(resultImg)
        }) */
        cb && cb(resultImgSrc)
    } 
    img.onerror = function () {
        failCb && failCb();
    }
}

function dataURLtoFile(dataurl, filename = 'file') {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let suffix = mime.split('/')[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
    })
}

/**
* @description 上传图片
* @param {opts} object 图片源文件
    file: 文件
    fileType: 后缀名 "jpg" "png"
    base64: 文件的base64 fileReader.readAsDataURL(file) 的result
* @param {opts} cb 成功回调
* @param {opts} clearInput 清除input的值
*/
export default (opts = {}, cb, clearInput) => {
    addWaterMarker(opts.base64, "仅限酷狗音乐认证使用", (resultImgBase64)=>{
        let IDImgUploadEle = null;
        IDImgUploadEle = new UploadImage({
            appid: 1014,
            bucket: 'h5privimg',
            bucketType: 3,
            salt: '54d387cb8cb5c706',
            form: "image/jpeg", //输出图片格式，'image/jpeg'、'image/png'，默认image/jpeg
            accept: "image/png,image/jpeg,image/jpg",
            fileSizeLimit: 10,
            fileSizeLimitTip: "请选择小于10MB的图片~",
            log: true,
            //上传成功回调
            result: urlArr => {
                window.eventEmitter.emit('loading', false)
            },
            //失败回调
            fail: (err) => {
                window.eventEmitter.emit('loading', false)
                clearInput();
                console.log(err);
                return window.$Msg(`上传失败，请稍后重试`);
            }
        });
        window.eventEmitter.emit('loading', true)
        IDImgUploadEle.uploadImg(resultImgBase64, (res)=>{
            console.log('upload result', res)
            clearInput();
            window.eventEmitter.emit('loading', false)
            if(res.status == 1){
                cb && cb(opts.base64, res.data['x-bss-filename'])
            }else{
                return window.$Msg(`上传失败，请稍后重试`);
            }
        })

        //http://doc.kugou.net/showdoc-master/web/#/9?page_id=34
        /* Axios({
            method: 'get',
            url: 'https://bssul.service.kugou.com/v2/authorization',
            params: {
                bucket: 'h5privimg',
                filename: md5(resultImgBase64)+`.${opts.fileType}`,
                method: 'POST',
                userid:　window.kugouid,
                token: window.token,
                appid: window.appid
            }
        }).then((res)=>{
            if(res.data.status === 1){
                var imgFile = dataURLtoFile(resultImgBase64, md5(resultImgBase64));//二进制file文件类型
                //http://doc.kugou.net/showdoc-master/web/#/9?page_id=21
                Axios({
                    method: 'post',
                    url: 'https://bssul.service.kugou.com/upload',
                    params: {
                        bucket: 'h5privimg',
                        extendname: opts.fileType,
                        use_ext: 1,
                        filename: md5(resultImgBase64)+`.${opts.fileType}`,
                        type: '',
                        authorization: res.data.data.authorization,
                        serverid: '',
                        appid: window.appid,
                        userid: window.kugouid,
                        token: window.token,
                        mid: window.mid,
                        dfid: window.KgUser ? window.KgUser.getDfid() : '-',
                        clientver: 1000,
                    },
                    data: imgFile
                }).then((response)=>{
                    if(response.data.status === 1){
                        clearInput();
                        cb && cb(resultImgBase64, response.data.data['x-bss-filename'])
                    }else{
                        clearInput();
                        console.log(response);
                        return window.eventEmitter.emit('toast', `上传失败，请稍后重试`);
                    }
                }).catch((err)=>{
                    clearInput();
                    window.eventEmitter.emit('toast', '服务器异常，请稍后重试')
                })
            }else{
                clearInput();
                console.log(res);
                return window.eventEmitter.emit('toast', `上传失败，请稍后重试`);
            }
        }).catch((err)=>{
            clearInput();
            window.eventEmitter.emit('toast', '服务器异常，请稍后重试')
        }) */
    },()=>{
        clearInput();
        return window.eventEmitter.emit('toast', `上传失败，请稍后重试`);
    })
    
}


// WEBPACK FOOTER //
// ./src/lib/newUpload.js